(function ($) {
	$(() => {
		$(document).on('input propertychange', 'input, textarea', function () {
			if($(this).closest('.form-group').hasClass('error')) {
				$(this).closest('.form-group').removeClass('error');
			}
		});

		$('#contact-form').submit(function (e) {
			const $this = $(this);
			$this.find('button[type=submit]').attr('disabled', 'disabled').find('span.loading').removeClass('d-none');
			e.preventDefault();
			const data = $this.serializeArray();
			data.push({name: 'data-type', value: $('.js-show-hidden-field').find(':selected').data('type')});
			data.push({name: 'action', value: 'contact_form_handle'});

			$('.form-group.error').removeClass('error');

			$.ajax({
				type: 'post',
				context: this,
				dataType: 'json',
				url: mg_ajax.ajaxurl,
				data: data,
				success(response) {
					let $type = 'error';
					if (response.success === true && response.data.status === 'ok') {
						$type = 'success';
						$this.trigger('reset');
					} else if (response.data.field) {
						$(`#${response.data.field}`).parent().parent().addClass('error');
					}

					Swal.fire({
						title: response.data.title,
						text: response.data.message,
						type: $type,
						confirmButtonClass: 'btn m-0',
						buttonsStyling: false
					});

					if ($type === 'error') {
						$('html, body').animate({scrollTop: $('.form-group.error').offset().top - 100}, 1000);
					}
				},
				error(response) {
					Swal.fire({
						title: response.data.title,
						text: response.data.message,
						type: 'error',
						confirmButtonClass: 'btn m-0',
						buttonsStyling: false
					});
				}
			});
			grecaptcha.reset();
			$this.find('button[type=submit]').attr('disabled', false).find('span.loading').addClass('d-none');
		});
	});
})(jQuery);
